
import { Component, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StageAdminService } from '@shared-angular/services/stage-admin.service';
import { SupervisorFunction } from '@shared/index';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { CodemirrorDannComponent } from "../../../../../../../../shared/components/ai-bot/utils/codemirror-dann/codemirror-dann.component";

@Component({
  selector: 'app-supervisor-functions-details',
  imports: [
    FormsModule,
    CodemirrorDannComponent,
    InputTextModule,
    ButtonModule
  ],
  templateUrl: './supervisor-functions-details.component.html',
  styleUrl: './supervisor-functions-details.component.scss'
})
export class SupervisorFunctionsDetailsComponent {
  @Input({ required: true }) set selectedFunctionId(value: string) {
    this._selectedFunctionId = value;
  }

  public readonly closeDrawer = output();

  private _selectedFunctionId: string = '';

  constructor(
    public rss: RouteShareService,
    protected stageAdmin: StageAdminService
  ) { }

  public get selectedFunction(): SupervisorFunction | undefined {
    return this.customFunctions.find((sf) => sf.id === this._selectedFunctionId);
  }

  public get customFunctions(): SupervisorFunction[] {
    return this.rss.botConfig.supervisorFunctions;
  }

  public selectPrevRule() {
    const currentIndex = this.customFunctions.findIndex(sf => sf.id === this._selectedFunctionId);
    let newIndex = currentIndex - 1;
    if (newIndex === -1) { newIndex = this.customFunctions.length - 1; }
    const newFunction = this.customFunctions[newIndex];
    if (newFunction) {
      this._selectedFunctionId = newFunction.id;
    }
  }

  public selectNextRule() {
    const currentIndex = this.customFunctions.findIndex(sf => sf.id === this._selectedFunctionId);
    let newIndex = currentIndex + 1;
    if (newIndex >= this.customFunctions.length) { newIndex = 0; }
    const newFunction = this.customFunctions[newIndex];
    if (newFunction) {
      this._selectedFunctionId = newFunction.id;
    }
  }

  public getSkillNames(): string[] {
    const skillsWithSkillId: string[] = [];
    const toolsWithSkillId = this.rss.botConfig.toolConfigs.filter(toolConfig => toolConfig.skillId !== '');
    skillsWithSkillId.push(...toolsWithSkillId.map(toolConfig => toolConfig.skillId + ''));
    const docsWithSkillId = this.rss.documents.filter(doc => doc.skillId !== '');
    skillsWithSkillId.push(...docsWithSkillId.map(doc => doc.skillId + ''));
    const datatrunksWithSkillId = this.rss.datatrunks.filter(datatrunk => datatrunk.skillId !== '');
    skillsWithSkillId.push(...datatrunksWithSkillId.map(datatrunk => datatrunk.skillId + ''));
    const webscrapesWithSkillId = this.rss.webscrapes.filter(webscrape => webscrape.skillId !== '');
    skillsWithSkillId.push(...webscrapesWithSkillId.map(webscrape => webscrape.skillId + ''));
    return skillsWithSkillId;
  }
}